export var _TextProcessingMode;
(function (_TextProcessingMode) {
    _TextProcessingMode[_TextProcessingMode["textExtraction"] = 0] = "textExtraction";
    _TextProcessingMode[_TextProcessingMode["textLayOut"] = 1] = "textLayOut";
    _TextProcessingMode[_TextProcessingMode["redaction"] = 2] = "redaction";
    _TextProcessingMode[_TextProcessingMode["textLineExtraction"] = 3] = "textLineExtraction";
})(_TextProcessingMode || (_TextProcessingMode = {}));
